import { useEffect, useState, useCallback , useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import Webcam from "react-webcam";
import moment from "moment";
import Select from 'react-select';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './FT.css';
import { CSolicitudPruebasClinicas } from '../CSolicitudPruebasClinicas';
import "moment/locale/es"; // Importa el idioma español

moment.locale("es");


let emp = 0;

const modeloDatos = {
    pacienteID:0,
    empresaid: emp
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , tipoOrden: 0
    , seguroID: 0
    , nombreSeguro: ''
    , poliza: ''
    ,centroID:0
    , diagnostico: ''
    , diagnosticoClinico: ''
    , direccion: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''
    , alergicos: ''
    , antecedentesMedicos: ''
    , antecedentesMedicamentos: ''
    , examenFisico: ''
    , antecedentesFamiliares: ''
    , habitosAlimenticios: ''


}
const modeloRecord = {
    recordPacienteGastroID: 0,
    empresaID: emp,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha: new Date,
    codigoUnico: ''
}
const modeloReceta = {
    recetaID: 0,
    empresaID: emp,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: '',
    dosificacion: '',
    CodigoUnicoRecord:''
}
const modeloHistoriaClinica = {
    historiID: 0,
    pacienteID: 0,
    empresaID: 1,
    nombrePaciente: '',
    edad: 0,
    seguroID: 0,
    nombreSegro: '',
    historiaEnfermedadActual: '',
    tiempoEvoluccion: '',
    antecedentePatologicoPersonales: '',
    estudiosRealizado: '',
    tratamientoPrevios: '',
    procedimientoSolicitado: '',
    fecha: new Date,
 creadoPor: '',
    fechaCreado: new Date,
    tipoReporte: 1,
    constatado: '',
    recomiendo: ''
   
}

const modeloDatosEmpresa = {
    empresaID: 0,
    siglas: "",
    descripcion: "",
    rnc: "",
    telefono: 1,
    direccion: "",
    email: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    estatus: true,
    logo: "",
    noWhatsapp: "",
    tokenWhatsapp: "",
    plantillaWhatsapp: ""

}

let options = [];
let optionsT = [{ descripcion: "" }];

let DetalleReceta = "";
const Gastro = () => {
     emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;
    const [imageSrc, setImageSrc] = useState("");

    const [tablaHistoria, setTablaHistoria] = useState(modeloHistoriaClinica);
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaT, setTablaT] = useState([]);
    const [tablaRecord, setTablaRecord] = useState(modeloRecord);
    const [tablaReceta, setTablaReceta] = useState(modeloReceta);
    const [Listado, SetListado] = useState([]);
    const [ListadoHistoria, SetListadoHistoria] = useState([]);
    const [ListadoSeg, SetListadoSeg] = useState([]);
    const [ListadoTox, SetListadoTox] = useState([]);
    const [ListadoRecord, SetListadoRecord] = useState([]);
    const [ListadoReceta, SetListadoReceta] = useState([]);
    const [ListadoMedicamento, SetListaMedicamento] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);
    const [Receta, SetReceta] = useState(false);
    const [Verrecord, SetVerrecord] = useState(false);
    const [Verrecetan, SetVerrecetan] = useState(false);
    const [VerEvaluacionPre, SetVerEvaluacionPre] = useState(false);
    const [VerSolicitud, SetVerSolicitud] = useState(false);
    const [NombreReceta, SetNombreReceta] = useState("");
    const [i, Seti] = useState(0);
    const [Impre, SetImpre] = useState({ nombres :"",apellidos:""});

    const [Inicio, SetInicio] = useState(false);
    const [pacientenombres, Setpacientenombres] = useState(new Date);
    const [verModalImpresion, setVerModalImpresion] = useState(false);
    const [verModalImpresion1, setVerModalImpresion1] = useState(false);
    const [vermodal, setvermodal] = useState(false);
    const [Empresa, setEmpresa] = useState(modeloDatosEmpresa);
    const [EvaluacionQ, setEvaluacionQ] = useState("")
    const [EvaluacionM, setEvaluacionM] = useState("")
    const [EvaluacionR, setEvaluacionR] = useState(``);
    
    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + emp);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

    //toast.configure();
    

    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;
       
        var searchData = l.filter((item) => {
            if (
                (item.nombres + item.apellidos + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const handleChangeT = (e) => {
     
        setTabla({
            ...tabla,
            ["toxicos"]: tabla.toxicos + ", " + e.target.value
        });

    }

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        if (e.target.name == "sexo") {
            icono(e.target.value)
        }
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }
        else {
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    }
    const handleChangeRecord = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaRecord({
            ...tablaRecord,
            [e.target.name]: e.target.value
        })
    }
    const handleChangeReceta = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaReceta({
            ...tablaReceta,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeHistoria = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaHistoria({
            ...tablaHistoria,
            [e.target.name]: e.target.value
        })
    }

    const handleChange2 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: e.value, ["nombreMedicamento"]: e.nombre, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }
    const handleChange3 = (e) => {
        setTablaReceta({
            ...tablaReceta,
            ["medicamentoID"]: 1, ["nombreMedicamento"]: e.value, ["pacienteiD"]: paciente.pacienteID, ["recordPacienteID"]: tablaRecord.recordPacienteGastroID
        })
    }


    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);
        setTabla({
            ...tabla, nombres: "", apellidos: "", cedula: x
        })
        if (nomb.length != 0) {
            var e = nomb[0].nombres + " EXISTE"
            MensajeG(e)
            setVerModal(!verModal);
            Setpaciente(nomb[0])
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    icono((data1[0]).sexo);
                    setTabla({
                        ...tabla, nombres: (data1[0]).nombres, apellidos: (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                        fechaNacimiento: (data1[0]).fechaNacimiento, sexo: (data1[0]).sexo
                    })
                } else {
                    setTabla({
                        ...tabla, nombres: "", apellidos:"",cedula: x
                    })
                }
            }
        }
    }

    const MensajeG= (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Pacientes/ListaGastro/" + correo +"/"+emp);
        if (response.ok) {
            let data1 = await response.json()
            let data = data1;
                //.filter(x => {
                //const fecha = new Date(x.fechaCreado); // Convertir a objeto Date
                //const fechaSolo = fecha.toISOString().split('T')[0]; // Extraer solo la fecha
                //return fechaSolo === FechaF.toISOString().split('T')[0]; // Comparar con la fecha deseada
            //})
            SetListado1(data);
            setPendiente(false)
            
            if (Inicio == false) {
                SetListado(data);
                SetInicio(true);
            }
          
           
            
        }
    }

    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + correo + "/"+emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }

    const obtenerDatosHistoria = async (e) => {
        let response = await fetch(Api + "Pacientes/ListaHistoriaGastro/" + e + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoHistoria(data)
        }
    }

    const ObtenerRecord = async (d) => {
        let response = await fetch(Api + "Pacientes/ListaRecordPacienteGastro/" + d + "/" + emp);
        if (response.ok) {
            let data = await response.json()
            SetListadoRecord(data)
        }
    }
    const ObtenerReceta = async (d, v) => {
        let response = await fetch(Api + "Pacientes/Recetas/" + d + "/" + emp);
        tablaRecord.recordPacienteGastroID = d
        if (response.ok) {
            let data = await response.json()
            SetListadoReceta(data)
        } if (v == 1) {
            SetReceta(true)
        }
    }
    const obtenerDatosEmpresa = async (d, v) => {
        let response = await fetch(Api + "Pacientes/Empresa/" + emp);
        if (response.ok) {
            let data = await response.json()
            setEmpresa(data)
        } 
    }
    const ObtenerMedicamento = async () => {
        let response = await fetch(Api + "Pacientes/Medicamentos/"+ emp);
        if (response.ok) {
            options=[]
            let data = await response.json()
            SetListaMedicamento(data)
            data.map(x => {
                options.push({
                    value: x.medicamentoID, label: x.descripcion , nombre: x.descripcion
                       })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
        obtenerDatosEmpresa();
        obtenerDatosSeg();
        fetchImage();
    }, [])

        useEffect(() => {
            ObtenerMedicamento();
            obtenerDatosToxico();
    }, [])


    const abrirRecord = (data) => {
        Setpaciente(data);
        ObtenerRecord(data.pacienteID);
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        var editando = 0;
        if (tabla.pacienteID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Pacientes/GuardarPacientesGastro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Pacientes/EditarPacientesGastro", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

            editando = 1;
        }

        if (response.ok) {
            SetInicio(false);
            obtenerDatos();
      
            let data1 = await response.json()
            if (editando == 0) {
                Setpaciente(data1)
            }
            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
         
            MensajeG("Guardado")
       
        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosRecord = async () => {
        let response;
        if (tablaRecord.recordPacienteGastroID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            tablaRecord.empresaID = JSON.parse(user).empresaID;
            response = await fetch(Api + "Pacientes/GuardarRecordPacienteGastro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
 
        } else {
            response = await fetch(Api + "Pacientes/EditarRecordPacienteGastro", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaRecord)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
            tablaRecord.recordPacienteGastroID = data1.recordPacienteGastroID
            tablaRecord.codigoUnico = data1.codigoUnico
            
            await ObtenerRecord();
            MensajeG("Guardado")
           // setTablaRecord(modeloRecord);
            SetReceta(true);
       
        } else {
            alert("error al guardar")
        }

    }

    const GuardarHistoriaGastro = async (d) => {
        let response;
        if (tablaHistoria.historiID == 0) {
        tablaHistoria.tipoReporte = d
            tablaHistoria.empresaID = JSON.parse(user).empresaID
            response = await fetch(Api + "Pacientes/GuardarHistoriaGastro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaHistoria)
            })
 
        } else {
            response = await fetch(Api + "Pacientes/EditarHistoriaGastro", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaHistoria)
            })
        }

        if (response.ok) {
            let data1 = await response.json()
                       
            await obtenerDatosHistoria(tablaHistoria.pacienteID);
            MensajeG("Guardado")
        
       
        } else {
            alert("error al guardar")
        }

    }
    const guardarCambiosReceta = async () => {
        let response;
        if (tablaReceta.recetaID == 0) {
            tablaRecord.pacienteID = paciente.pacienteID;
            tablaRecord.empresaID = paciente.empresaID;
            
            response = await fetch(Api + "Pacientes/GuardarReceta", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        } else {
            response = await fetch(Api + "Pacientes/EditarReceta", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaReceta)
            })
        }

        if (response.ok) {

            await ObtenerReceta(tablaRecord.recordPacienteGastroID);
          
            SetReceta(modeloReceta);
            MensajeG()
           // Setpaciente([]);
       
        } else {
            alert("error al guardar")
        }

    }
    const EliminarReceta = async (id) => {
        const response = fetch(Api + "Pacientes/EliminarReceta/" + id, { method: "DELETE" })
            .then(response => {
                if (response.ok) {
                    ObtenerReceta(tablaRecord.recordPacienteGastroID)
                }
            })}
    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            SetInicio(false)
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const HistoriaClinica = (data) => {
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad =  calcularEdad(data.fechaNacimiento,moment(new Date()).format("YYYY-MM-DD")) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
        setVerModalImpresion(!verModalImpresion);
    }
    const HistoriaClinica2 = (data) => {
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad =  calcularEdad(data.fechaNacimiento,moment(new Date()).format("YYYY-MM-DD")) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.sexo = data.sexo;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
      setEvaluacionQ(""   );
     SetVerEvaluacionPre(true)  
    }
    const HistoriaClinica1 = (data) => {
        tabla.cedula = data.cedula
        obtenerDatosHistoria(data.pacienteID)
        tablaHistoria.pacienteID = data.pacienteID;
        tablaHistoria.nombrePaciente = data.nombres + ' ' + data.apellidos;
        tablaHistoria.edad = calcularEdad(data.fechaNacimiento, new Date()) ;
        tablaHistoria.seguroID = data.seguroID;
        tablaHistoria.nombreSeguro = data.nombreSeguro;
        tablaHistoria.antecedentePatologicoPersonales = data.antecedentesMedicos;
        setVerModalImpresion1(!verModalImpresion1);
    }
    
    const RecetaEnBlanco =async (data) => {
      SetVerrecetan(true)
        SetNombreReceta("alejra")
        Setpaciente(data)
        
    }
   

      

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setVerModalImpresion(false)
        setVerModalImpresion1(false)

        SetListadoReceta([])
        SetVerrecetan(false)
        Setpaciente([])
    }

    const columns = [
 
        {
            name: 'Pacientes ',
            selector: row => row.nombres +" "+ row.apellidos ,
            sortable: true,
            width: window.innerWidth < 844 ? '25%' : '20%',
        },
        {
            name: 'Telefono ',
            selector: row => row.telefono,
            sortable: true,
            omit: window.innerWidth <= 845,
            width: '10%'
        }, {
            name: 'Seguro ',
            selector: row => ( row.nombreSeguro),
            sortable: true,
            omit: window.innerWidth < 844,
            width: '15%'
        },

        {
            name: 'IMPORTANTE RECORDAR ',
            selector: row => (row.diagnosticoClinico),
            sortable: true,
            style: {
                color: "red"

            },
            omit: window.innerWidth < 844,
            width: '20%'
        },
        {
            name: 'Ultima Consulta',
            selector: row => (moment( row.fechavisita).format("DD/MM/YYYY")),
            sortable: true,
            omit: window.innerWidth < 844,
            width: '10%'
        },


       
        {
            name: '',
           
            cell: row => (
                <>
                   
                   
                    <Button class="btn" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)} title="Editar Paciente"
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirRecord(row)} title="Proceso de Consulta"
                    >
                        <i className="fas fa-user-tag"></i>
                    </Button>
                   <Button type="button" onClick={() => (setvermodal(true), SetImpre(row))} class="btn mr-2 "  title="Imprimir Certificaciones">
                            <i className="fas fa-print"></i>
                        </Button>  
                   

                </>
            ), width: window.innerWidth < 844 ? '15%' : '20',
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    const videoConstraints = {
        width: 20,
        height: 20,
        facingMode: "user"
    };
    const webcamRef = useRef(null);
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            SetCamara(false)
        
            tabla.imagen = imageSrc;
            document.getElementsByName("imagen").value = imageSrc;
        },
        [webcamRef]
  
    );
    const Atras =() =>{
        Setpaciente([])
    }
    const TerminarReceta = (d) => {
       
        if (d != '0') {
            imprimirRecibo3()
        //    window.open("/ImpresionReceta/" + d + "/ImpresionReceta.html" + "/Gastro", '_blank');
        }
        
        obtenerDatos()
        Setpaciente([])
        setTablaReceta(modeloReceta)
        setTablaRecord(modeloRecord)
        SetReceta(false)
     
    }
    const icono = (d)=> {
        const profileIcon = document.getElementById('profileIcon');
        if (d === 'F') {
            profileIcon.innerHTML = '👩';
        } else if (d === 'M') {
            profileIcon.innerHTML = '👨';
        } else {
            profileIcon.innerHTML = '👤';
        }
    };


    const obtenerDatosToxico = async () => {
        let response = await fetch(Api + "CMantenimiento/listaToxicos");
        if (response.ok) {
            let data = await response.json()
            SetListadoTox(data)
      
        }
    }

    function calcularEdad(fechaNacimiento, fechaActual) {
        var nacimiento = new Date(fechaNacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }
    const [cssContent, setCssContent] = useState('');
    useEffect(() => {
        fetch('/css/Gastro.css')
            .then(response => response.text())
            .then(text => setCssContent(text))
            .catch(error => console.error('Error al cargar el CSS:', error));
    }, []);

    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Historia clinica</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");
        ventana.document.write(` <div class="headerM container"> 
                          
                        </div>      ${recibo}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        //const logoImg = ventana.document.getElementById("logoImg");
        //logoImg.onload = function () {

        //};
        setTimeout(() => {
            ventana.print();
        }, 2000);
        cerrarModal()
       cerrarModalR()
    };


    const imprimirRecibo1 = () => {
        const recibo1 = document.getElementById("reciboPago1").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Certificado</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        setTimeout(() => {
            ventana.print();
        }, 2000);
        cerrarModal()
        cerrarModalR()
    };


    const imprimirRecibo2 = () => {
        const recibo1 = document.getElementById("reciboPago2").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title></title><style>");
        ventana.document.write(cssContent);
        ventana.document.write(`</style></head><body style="color:#000">`);
        ventana.document.write(` <div> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        setTimeout(() => {
            ventana.print();
        }, 2000);
        cerrarModal()
        cerrarModalR()
    };

    const imprimirRecibo3 = () => {
       
        const recibo1 = document.getElementById("reciboPago3").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title></title><style>");
        ventana.document.write(cssContent);
        ventana.document.write(`</style></head><body style="color:#000">`);
        ventana.document.write(` <div "> 
                          
                        </div>      ${recibo1}  </body></html>`);
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg1 = ventana.document.getElementById("logoImg1");
        setTimeout(() => {
            ventana.print();
        }, 2000);
        cerrarModal()
        cerrarModalR()
    };

    const RimprimirRecibo =  async(d) => {
        setTablaHistoria(d)
     
    }
    const cerrarModalR = () => {
        setTablaRecord(modeloRecord)
        SetVerrecord(false)
        SetVerEvaluacionPre(false)
        SetVerSolicitud(false)
    }
    const guardarCambiosRecetaBlanco = () => {
        SetListadoReceta([
            ...ListadoReceta,
            tablaReceta
        ])
    }
    const eliminarReceta = (indiceAEliminar) => {
        const nuevaLista = ListadoReceta.filter((_, index) => index !== indiceAEliminar);
        SetListadoReceta(nuevaLista);
    };
    return (
        <>
            
            <ToastContainer />
            <div hidden={paciente.length == 0} >


                <div class="containerR">

                    <div class="">

                        <h1>Consulta Médica</h1>
                    </div>
                    <div class="patient-info">
                        <div class="info-item">
                            <span class="info-label">Nombres y Apellidos:</span>
                            {paciente.nombres + " " + paciente.apellidos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Edad:</span>

                            {calcularEdad(paciente.fechaNacimiento, new Date())}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Móvil:</span>
                            {paciente.celular} /  {paciente.telefono}
                        </div>
                        <div class="info-item">
                            <span class="info-label">ARS:</span>
                            {paciente.nombreSeguro}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Afiliado:</span>
                            {paciente.poliza}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Tóxicos:</span>
                            {paciente.toxicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Alergicos:</span>
                            {paciente.alergicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Antecedentes Medicos:</span>
                            {paciente.antecedentesMedicos}
                        </div>
                        <div class="info-item">
                            <span class="info-label">Antecedentes Medicamentos:</span>
                            {paciente.antecedentesMedicamentos}
                        </div>
                        <div class="info-item" style={{ color: "red" }}>
                            <span class="info-label" style={{ color: "red" }}>MUY IMPORTANTE RECORDAR:</span>
                            {paciente.diagnosticoClinico}
                        </div>
                    </div>

                    <div class="col-md-16" >
                        <Row>
                            <Col Col="6">
                                <h4><b>Consulta</b></h4>
                                <textarea placeholder="Historia Clínica" name="historiaClinica"
                                    onChange={handleChangeRecord} value={tablaRecord.historiaClinica} ></textarea>
                                <textarea placeholder="Comentario" name="comentario" value={tablaRecord.comentario}
                                    onChange={handleChangeRecord}></textarea>

                                <div class="btn-group">
                                    <button type="button" onClick={Atras} class="btn btn-danger">Cerrar</button>
                                    <button type="button" class="btn btn-primary" onClick={guardarCambiosRecord} hidden={!tablaRecord.historiaClinica}>Siguiente</button>
                                </div>
                            </Col>
                            <div className="col-md-6">
                                <h4><b>Historial de consulta</b></h4>
                                <table >
                                    <thead>
                                        <tr>
                                            <th>Fecha  </th>
                                            <th>Descripción</th>
                                            <th>Comentario</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ListadoRecord.map(x => (
                                            <tr>
                                                <td>{moment(x.fecha).format("DD/MM/YY")}</td>
                                                <td >
                                                    <textarea rows="2" value={x.historiaClinica} disabled></textarea>
                                                </td>
                                                <td>
                                                    <textarea rows="2" value={x.comentario} disabled></textarea>
                                                </td>
                                                <td><Button class="print-icon" target="_blank"
                                                    onClick={() => ObtenerReceta(x.recordPacienteGastroID, 1)} title="Impresion de Receta"                                           
                                                >🖨️</Button></td>

                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>






            <Col md="12" hidden={paciente.length != 0}>
                <Card>
                    <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                        <Row>
                            {/*<Col hidden md="2" ><Input type="date" onChange={(e)=>SetFechaF(e.target.value) } />  </Col>*/}
                            <Col md="7" >
                                <Input type="search" name="busqueda" onChange={(e) => onBusqueda(e)} placeholder="Busqueda de paciente " ></Input></Col>

                            <Col md="4" >

                                <Button color="success" size="md"
                                    onClick={() => setVerModal(!verModal)}
                                ><b>Nuevo Paciente</b></Button>
                                <Button color="warning" size="md"
                                    href="/ReportesGastro"
                                ><b>Reporte</b></Button>
                            </Col></Row>
                    </CardHeader>
                    <CardBody>

                        <DataTable
                            columns={columns}
                            data={Listado}
                            progressPending={pendiente}
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}


                        />
                    </CardBody>
                </Card>
            </Col>



            <Modal className="modal-preguntas" isOpen={verModal}>

                <ModalBody>


                    {/*                   <Row>*/}

                    <div class="containerp">
                        <div class="form-header">
                            <div class="box">
                                <div>Record del Paciente </div>
                                <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                            </div>

                            <div id="profileIcon" class="profile-icon">👤</div>
                        </div>
                        <form class="form-content">
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="cedula">Cédula</label>
                                        <input type="text" id="cedula" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="nombres">Nombres</label>
                                        <input type="text" id="nombres" name="nombres" value={tabla.nombres}
                                            placeholder="Nombres" onChange={handleChange} required />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="apellidos">Apellidos</label>
                                        <input type="text" id="apellidos" name="apellidos" value={tabla.apellidos}
                                            placeholder="Apellidos" onChange={handleChange} required />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="telefono">Teléfono</label>
                                        <input type="tel" id="telefono" name="telefono" mask="999-999-9999"
                                            value={tabla.telefono} onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="celular">Celular</label>
                                        <input type="tel" id="celular" name="celular" mask="999-999-9999" onChange={handleChange} value={tabla.celular} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="fechaNacimiento">Fecha de Nacimiento</label>
                                        <input type="date" id="fechaNacimiento" name="fechaNacimiento" value={Moment(tabla.fechaNacimiento).format('YYYY-MM-DD')}
                                            placeholder="FechaNacimiento" onChange={handleChange} />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="sexo">Sexo</label>
                                        <select id="sexo" name="sexo" value={tabla.sexo} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="seguro">Seguro</label>
                                        <select id="seguroID" name="seguroID"
                                            value={tabla.seguroID} onChange={handleChange} >
                                            <option value="">Seleccione</option>
                                            {ListadoSeg.map(x =>
                                                <option value={x.seguroID}> {x.descripcion}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="afiliado">Afiliado</label>
                                        <input type="text" id="poliza" name="poliza" value={tabla.poliza}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Seleccione el Tóxicos</label>
                                        <select
                                            value={tabla.toxicos} onChange={handleChangeT} >
                                            <option value="">Seleccione</option>
                                            {ListadoTox.map(x =>
                                                <option value={x.descripcion}> {x.descripcion}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Descripcion de lo Toxicos</label>
                                        <input type="text" id="toxicos" name="toxicos" value={tabla.toxicos} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnostico">Diagnóstico</label>
                                        <input type="text" id="diagnostico" name="diagnostico" value={tabla.diagnostico} id="diagnostico"
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>

                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="diagnosticoClinico" style={{ color: "red" }} >DIAGNOSTICO CLINICO IMPORTANTE PARA RECORDAR</label>
                                        <input type="text" id="diagnosticoClinico" name="diagnosticoClinico" value={tabla.diagnosticoClinico}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Familiares</label>
                                        <input type="text" id="antecedentesFamiliares" name="antecedentesFamiliares" value={tabla.antecedentesFamiliares}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Alergicos</label>
                                        <input type="text" id="alergicos" name="alergicos" value={tabla.alergicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicos</label>
                                        <input type="text" id="antecedentesMedicos" name="antecedentesMedicos" value={tabla.antecedentesMedicos}
                                            onChange={handleChange} />
                                    </div>
                                </div>         <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Antecedentes Medicamentos</label>
                                        <input type="text" id="antecedentesMedicamentos" name="antecedentesMedicamentos" value={tabla.antecedentesMedicamentos}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>
                            <div class="form-row">
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="toxicos">Examen Fisico</label>
                                        <input type="text" id="examenFisico" name="examenFisico" value={tabla.examenFisico}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                                <div class="form-col">
                                    <div class="form-group">
                                        <label for="resultado">Habitos Alimenticios</label>
                                        <input type="text" id="habitosAlimenticios" name="habitosAlimenticios" value={tabla.habitosAlimenticios}
                                            onChange={handleChange} />
                                    </div>
                                </div>

                            </div>

                            <div class="form-group">
                                <label for="direccion">Dirección</label>
                                <input type="text" id="direccion" name="direccion" value={tabla.direccion} id="Direccion"
                                    onChange={handleChange} />
                            </div>

                            <div class="btn-group">
                                <button type="button" onClick={cerrarModal} class="btn btn-danger">Cerrar</button>
                                <button type="button" class="btn btn-primary" onClick={guardarCambios}>Guardar</button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </Modal>

            <Modal isOpen={Camara}>
                <ModalHeader>
                    TOMAR FOTO
                </ModalHeader>
                <ModalBody>
                    <div >
                        <Webcam
                            audio={false}
                            height={400}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={400}
                            videoConstraints={videoConstraints}
                        />
                        <button onClick={capture}>Tomar Foto</button>

                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => SetCamara(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={Receta} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Receta a Nombre de:  {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => TerminarReceta(0)}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div >
                        <Row>
                            <Col md="3">  <FormGroup>

                                <Label>* Medicamento</Label>
                                <Input onChange={(e) =>handleChange3(e.target)}></Input>
                            <div hidden>    <Select 
                                    name={"medicamentoID"}
                                    onChange={handleChange2}
                                    value={options.filter(x => x.value == tablaReceta.medicamentoID).map(x => x)}
                                    options={options}
                                /></div>
                            </FormGroup></Col>


                            <Col md="2">  <FormGroup > <Label for="exampleEmail">Dosificacion</Label>
                                <Input type="text" name="dosificacion" value={tablaReceta.dosificacion} id="comentario"
                                    placeholder="dosificacion" onChange={handleChangeReceta} />

                            </FormGroup>  </Col>
                            <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                    placeholder="Comentario" onChange={handleChangeReceta} />

                            </FormGroup>  </Col>
                            <Col md="2">
                                <Button size="sm" color="primary"
                                    onClick={guardarCambiosReceta}
                                >Agregar</Button></Col>

                        </Row>
                        <table>
                            <tr>
                                <th>Medicamento</th>
                                <th>Dosificacion</th>
                                <th>Comentario</th>
                                <th>Quitar</th>
                            </tr>
                            {ListadoReceta.map(x => (
                                <tr>
                                    <td>{x.nombreMedicamento}</td>
                                    <td>{x.dosificacion}</td>
                                    <td>{x.comentario}</td>
                                    <td> <Button size="sm" color="danger"
                                        onClick={() => EliminarReceta(x.codigoUnico)}
                                    >X</Button></td>
                                </tr>
                            ))}
                        </table>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" size="sx" target="_blank"
                        onClick={() => TerminarReceta(tablaRecord.codigoUnico)}
                    ><i className="fa fa-print"></i></Button>
                    <Button size="sm" color="danger"
                        onClick={() => TerminarReceta(0)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*////Recibo*/}
            <Modal isOpen={verModalImpresion} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    
                    <div class="box">
                        <div> Historia clinica de : {tablaHistoria.nombrePaciente} </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div>

                        <Row>

                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Historia Enfermedad Actual</Label>
                                    <textarea name="historiaEnfermedadActual"
                                        onChange={handleChangeHistoria} value={tablaHistoria.historiaEnfermedadActual} ></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Tiempo Evoluccion</Label>
                                    <textarea name="tiempoEvoluccion" value={tablaHistoria.tiempoEvoluccion}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>

                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Antecedente Patologico Personales</Label>
                                    <textarea name="antecedentePatologicoPersonales" value={tablaHistoria.antecedentePatologicoPersonales}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Estudios Realizado</Label>
                                    <textarea name="estudiosRealizado" value={tablaHistoria.estudiosRealizado}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Tratamiento Previos</Label>
                                    <textarea name="tratamientoPrevios" value={tablaHistoria.tratamientoPrevios}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Procedimiento Solicitado</Label>
                                    <textarea name="procedimientoSolicitado" value={tablaHistoria.procedimientoSolicitado}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>


                        </Row>
                        <div style={{ textAlign: "right" }}>
                            <Button color="secondary" size="sm" onClick={() => imprimirRecibo()}>Imprimir Recibo</Button>
                            {(tablaHistoria.historiID != 0) ? (<Button color="success" size="sm" onClick={() => setTablaHistoria(modeloHistoriaClinica)}>Nuevo</Button>) : (<Button color="success" size="sm" onClick={() => GuardarHistoriaGastro(2)}>GUARDAR</Button>)}

                        </div>

                        <wbr />




                    </div>
                    <div>
                        <h5>Historias anteriores</h5>
                        <table className="tabla min-w-full">
                            <tr>
                                <th>Fecha</th>
                                <th>Precedimiento solicitado</th>
                                <th>Imprimir</th>
                            </tr>
                            {(ListadoHistoria.length < 1) ? ("No hay registros anteriores") : (
                                ListadoHistoria.filter(t => t.tipoReporte == 2).map(x => (<tr>
                                    <td> {moment(x.fecha).format("DD/MM/YYYY")}</td>
                                    <td> {x.procedimientoSolicitado}</td>
                                    <td>   <Button color="secondary" size="sm" onClick={() => RimprimirRecibo(x)}>Ver Historia</Button></td>
                                </tr>
                                )))}
                        </table>

                    </div>
                    <div id="reciboPago" className="mt-4 p-3" hidden>
                        <div class="hoja-timbrada">
                        <div class="container" style={{color:"#000"} } >

                            <div class="headerR" style={{ background: "none" }}>
                                <img src="http://pichardo.systemapatech.com/imagen/mallaizquierda.webp" alt="Logo Izquierdo" class="logo-left" />
                                <img src="http://pichardo.systemapatech.com/imagen/malladerecha.webp" alt="Logo Derecho" class="logo-right" />
                                {/*<img src="http://pichardo.systemapatech.com/imagen/logogastro.webp" alt="Logo Central" class="logo-center" style={{ width: "200px" }} />*/}
                                    <img src={imageSrc} alt="Logo Central" class="logo-center" style={{ width: "150px" }} />
                                <h1 style={{ marginTop: "-10px" }} >{Empresa.descripcion}</h1>

                                <p class="subtitle">{Empresa.tokenWhatsapp}</p>
                                {/*<p class="subtitle">Medicina Interna | Gastroenterología | Endoscopia Digestiva | Balón Gástrico</p>*/}

                                <p class="subtitle">Exequátur No.{Empresa.plantillaWhatsapp} </p>{/*71204*/}
                           
                            </div>

                            <div class="title">HISTORIA CLÍNICA</div>


                            <div class="info-section">
                                <span class="label">FECHA: </span>
                                <span class="lineH">{moment(tablaHistoria.fecha).format("DD/MM/YYYY")}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">NOMBRE DEL PACIENTE:</span>
                                <span class="lineH"> {tablaHistoria.nombrePaciente}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">EDAD:</span>
                                <span class="lineH">{tablaHistoria.edad}</span>
                            </div>
                            <div class="info-section">
                                <span class="label">SEGURO: </span>
                                <span class="lineH">{tablaHistoria.nombreSeguro}</span>
                            </div>


                            <div class="block-title">HISTORIA DE LA ENFERMEDAD ACTUAL</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.historiaEnfermedadActual}</span></li>

                            </ul>

                            <div class="block-title">TIEMPO DE EVOLUCIÓN</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.tiempoEvoluccion}</span></li>
                            </ul>

                            <div class="block-title">ANTECEDENTES PATOLÓGICOS PERSONALES</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.antecedentePatologicoPersonales}</span></li>
                            </ul>

                            <div class="block-title">ESTUDIOS REALIZADOS</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.estudiosRealizado}</span></li>

                            </ul>

                            <div class="block-title">TRATAMIENTOS PREVIOS</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.tratamientoPrevios}</span></li>
                            </ul>

                            <div class="block-title">PROCEDIMIENTO SOLICITADO</div>
                            <ul class="bullet-list">
                                <li><span class="bullet-line">{tablaHistoria.procedimientoSolicitado}</span></li>

                            </ul>

                            <br></br>
                            <div class="signature">
                                {/*<div class="name">ANA YDALINA PICHARDO NÚÑEZ</div>*/}
                                <div class="name">{Empresa.descripcion}</div>
                                <div class="specialty">{Empresa.tokenWhatsapp}</div>
                                {/*<div class="specialty">MÉDICO GASTROENTERÓLOGO-ENDOSCOPISTA</div>*/}
                            </div>
                        </div>
                    </div>
                    </div>


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*////Recibo examinado*/}
            <Modal isOpen={verModalImpresion1} className="modal-preguntas" >
                <ModalHeader className=" modal-header1" >
                   
                    <div class="box">
                        <div> Certificado clinico de : {tablaHistoria.nombrePaciente} </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div>

                        <Row>

                            <Col md={6}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Constatado</Label>
                                    <textarea name="constatado"
                                        onChange={handleChangeHistoria} value={tablaHistoria.constatado} ></textarea>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="Historia Enfermedad Actual">Recomendado</Label>
                                    <textarea name="recomiendo" value={tablaHistoria.recomiendo}
                                        onChange={handleChangeHistoria}></textarea>
                                </FormGroup>
                            </Col>


                        </Row>


                        <div style={{ textAlign: "right" }}>
                            <Button color="secondary" size="sm" onClick={() => imprimirRecibo1()}>Imprimir Certificado</Button>
                            {(tablaHistoria.historiID != 0) ? (<Button color="success" size="sm" onClick={() => setTablaHistoria(modeloHistoriaClinica)}>Nuevo</Button>) : (<Button color="success" size="sm" onClick={() => GuardarHistoriaGastro(1)}>GUARDAR</Button>)}

                        </div>

                        <hr />




                    </div>
                    <div >
                        <h5>Certificados Guardados anteriores</h5>
                        <table className="tabla min-w-full">
                            <tr>
                                <th>Fecha</th>
                                <th>Constatado</th>
                                <th>Recomiendo</th>
                                <th>Imprimir</th>
                            </tr>
                            {(ListadoHistoria.length < 1) ? ("No hay registros anteriores") : (
                                ListadoHistoria.filter(t => t.tipoReporte == 1).map(x => (<tr>
                                    <td> {moment(x.fecha).format("DD/MM/YYYY")}</td>
                                    <td> {x.constatado}</td>
                                    <td> {x.recomiendo}</td>
                                    <td>   <Button color="secondary" size="sm" onClick={() => RimprimirRecibo(x)}>Ver Historia</Button></td>
                                </tr>
                                )))}
                        </table>

                    </div>
                    <div id="reciboPago1" hidden className="mt-4 p-3" >
                      

                            <div class="rotar-90">

                                <div class="hoja-timbrada">
                                    <div class="MediapaginaHorizontal">
                        <div class="certificate bodycert">
                       

                            <div class="headercert">
                                <div class="gold-curve"></div>
                            </div>


                            <div class="doctor-name">
                                <h1>{Empresa.descripcion}</h1>
                                <div class="gold-line"></div>
                            </div>


                            <div class="specialties">

                                {Empresa.tokenWhatsapp}
                                {/*<p>Medicina Interna · Gastroenterología</p>*/}
                                {/*<p>Endoscopía Digestiva · Nutrición Clínica</p>*/}
                            </div>


                            <div class="contact-info">
                                <p>{Empresa.direccion} Tels.: {Empresa.telefono} </p>
                                    {/*Clínica Dr. Rodríguez Santos: Calle Bartolomé Colón, No. 20 • Tels.: 809-333-6671 Ext. 649</p> daly008@hotmail.com*/}
                                <p>Directo: {Empresa.noWhatsapp} • Celular: 829-343-6584 • E-mail:{Empresa.email }</p>
                            </div>


                            <div class="form-container">
                                <p>
                                    <span class="bold">Yo </span>
                                    <span class="bold italic">{Empresa.descripcion}</span><span>,</span>
                                    <span> Médico provisto del correspondiente exequátur No. </span>
                                    <span class="bold">{Empresa.plantillaWhatsapp }</span> de cédula de Identidad y Electoral No.  <span class="bold">{Empresa.rnc}</span>{/*05500318414*/}
                                </p>
{/*71204*/}
                                <p class="bold">CERTIFICO haber examinado a:</p>
                                <div class="linecert"> {tablaHistoria.nombrePaciente}</div>

                                <p>Cédula de Identidad y Electoral No. <b>{tabla.cedula}</b></p>

                                <p>y constatado:</p>
                                <div class="linecert">{tablaHistoria.constatado}</div>


                                <p class="bold">Por lo que recomiendo</p>
                                <div class="linecert">{tablaHistoria.recomiendo}</div>



                                <div style={{height:"100px"} }></div>

                                <p>Expido la presente Certificación en Santo Domingo a petición del interesado.</p>

                                <p>Hoy día <b>{moment(new Date()).format("DD")}</b> del mes de <b>{moment(new Date()).format("MMMM")}</b> del año <b>{moment(new Date()).format("YYYY")}</b> </p>

                                <div class="signature-line"></div>
                                <p class="signature-text"><b>Firma del Médico y Sello</b></p>
                            </div>

                            <div class="footer">
                                <p></p>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    </div>


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*Embarazada*/}

            <Modal isOpen={Verrecord} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Embarazada: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModalR()}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div>
                        <Row>
                            <div class="col-md-6">
                                <h4 class="mb-4"><b>Consulta</b></h4>

                                <form>


                                    <div class="mb-3">
                                        <label for="historiaClinica" class="form-label">Historia Clínica</label>
                                        <textarea class="form-control" id="historiaClinica" name="historiaClinica" rows="3"
                                            value={tablaRecord.historiaClinica}></textarea>
                                    </div>

                                    <div class="mb-3">
                                        <label for="comentario" class="form-label">Comentario</label>
                                        <textarea class="form-control" id="comentario" name="comentario" rows="3"
                                            value={tablaRecord.comentario}></textarea>
                                    </div>


                                </form>
                            </div>

                            {/*Segunda Seccion*/}
                            <div class="col-md-6" >
                                <h4 class="mb-4"><b>Medicamento Receta</b></h4>
                                <table>
                                    <tr>
                                        <th>Medicamento</th>
                                        <th>Dosificacion</th>
                                        <th>Comentario</th>
                                    </tr>
                                    {ListadoReceta.map(x => (
                                        <tr>
                                            <td>{x.nombreMedicamento}</td>
                                            <td>{x.dosificacion}</td>
                                            <td>{x.comentario}</td>

                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Recetario*/}

            <Modal isOpen={Verrecetan} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Receta de: {paciente.nombres + " " + paciente.apellidos}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModal()}>X</a></div>
                    </div>

                </ModalHeader>
                <ModalBody>
                    <div>
                      
                        <div>
                            <Row>
                                <Col md="3">  <FormGroup>

                                    <Label>* Medicamento</Label>
                                    <Input onChange={handleChangeReceta} name="nombreMedicamento"></Input>
                                   </FormGroup></Col>


                                <Col md="2">  <FormGroup > <Label for="exampleEmail">Dosificacion</Label>
                                    <Input type="text" name="dosificacion" value={tablaReceta.dosificacion} id="comentario"
                                        placeholder="dosificacion" onChange={handleChangeReceta} />

                                </FormGroup>  </Col>
                                <Col md="4">  <FormGroup > <Label for="exampleEmail">Comentario</Label>
                                    <Input type="text" name="comentario" value={tablaReceta.comentario} id="comentario"
                                        placeholder="Comentario" onChange={handleChangeReceta} />

                                </FormGroup>  </Col>
                                <Col md="2" hidden={tablaReceta.nombreMedicamento == '' }>
                                    <Button size="sm" color="primary"
                                        onClick={guardarCambiosRecetaBlanco}
                                    >Agregar</Button></Col>

                            </Row>
                        </div>
                        <table class=""  style={{  textTransform: "uppercase" }}>
                            <thead>
                                <tr>
                                    <th>nombreMedicamento</th>
                                    <th>dosificacion</th>
                                    <th>comentario</th>
                                   
                                </tr>
                            </thead>
                            {ListadoReceta.map((x,index) => (
                                <tr key={index}>
                                  
                                    <td style={{ padding: "10px" }}>{x.nombreMedicamento}</td>
                                    <td style={{ padding: "10px" }}>{x.dosificacion}</td>
                                    <td style={{ padding: "10px" }}>{x.comentario}</td>
                                    <td>
                                        <Button onClick={() => eliminarReceta(index)} size="sm" color="danger"><i className="fa fa-trash"></i></Button>
                                    </td>
                                </tr>
                            ))}
                        </table>
                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="success"
                        onClick={() => imprimirRecibo3()}
                    >Imprimir</Button>
                    <Button size="sm" color="danger"
                        onClick={() => cerrarModal()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>





            <Modal isOpen={VerEvaluacionPre} className="modal-preguntas">
                <ModalHeader className="modal-header1" toggert={cerrarModalR} >
            
                   
                    <div class="box">
                        <div>           EVALUACION QUIRURGICA: {tablaHistoria.nombrePaciente}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModalR()}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                
                    <div class="patient-info">
                        <p><span class="label" style={{ textDecoration: "underline" }}>NOMBRE:</span> {tablaHistoria.nombrePaciente}</p>
                        <p><span class="label" style={{ textDecoration: "underline" }}>EDAD:</span> {tablaHistoria.edad} AÑOS</p>
                        <p><span class="label" style={{ textDecoration: "underline" }}>MOTIVO:</span> <Input onChange={(e) => setEvaluacionM(e.target.value)}
                            value={EvaluacionM}
                        ></Input></p>
                    </div>

                    <div> <label class="form-label">EVALUACIÓN PRE-QUIRÚRGICA</label>
                        <Input type="textarea" rows={5}
                            onChange={(e) => setEvaluacionQ(e.target.value)}
                            value={EvaluacionQ}
                        ></Input>
                    </div>
                    <br></br>

                    <div> <label class="form-label">RECOMENDACIONES:</label>
                        <Input type="textarea" rows={5}
                            onChange={(e) => setEvaluacionR(e.target.value)}
                            value={EvaluacionR}
                        ></Input>
                    </div>


                    <Button size="sm" color="success"
                        onClick={() => imprimirRecibo2()}
                    >Imprimir</Button>

                    <div id="reciboPago2" hidden className="mt-4 p-3 hoja-timbrada" style={{ color: "#000 !important" }} >
                        {/*<!-- Header with logo and title -->*/}
                        <div class="hoja-timbrada">
                            <div style={{ padding: "40px"} }>
                        <div class="header" style={{ background: "none" }}>

                            {/*<img class="logo" style={{ width: "80px", height: "74px" }} src="http://pichardo.systemapatech.com/imagen/LogoPichardoCirugia.jpg" alt="Logo Médico" />*/}
                                    <img class="logo" style={{ width: "80px", height: "74px" }} src={imageSrc} alt="Logo Médico" />
                            <div class="title">
                                <h2 style={{ textDecoration: "underline" }}>{Empresa.descripcion}</h2>
                                <h2 style={{ textDecoration: "underline" }}>{Empresa.tokenWhatsapp}</h2>
                                {/*<h2 style={{ textDecoration: "underline" }}>MEDICINA INTERNA-GASTROENTEROLOGÍA</h2>*/}
                            </div>
                        </div>
                        <br></br>
                        {/*<!-- Patient Information -->*/}
                        <div class="patient-info">
                            <p><span class="label" style={{ textDecoration: "underline" }}>NOMBRE:</span> {tablaHistoria.nombrePaciente}</p>
                            <p><span class="label" style={{ textDecoration: "underline" }}>EDAD:</span> {tablaHistoria.edad} AÑOS</p>
                            <p><span class="label" style={{ textDecoration: "underline" }}>MOTIVO:</span> {EvaluacionM}</p>
                        </div>
                        <br></br>
                        {/* <!-- Evaluation Section -->*/}
                        <h3 class="evaluation-title" style={{ textDecoration: "underline" }}>EVALUACIÓN PRE-QUIRÚRGICA</h3>

                        <div class="evaluation-content">
                            <p style={{ whiteSpace: 'pre-line' }}>{EvaluacionQ}</p>
                        </div>
                        <br></br>
                        {/* <!-- Recommendations -->*/}
                        <div class="recommendations">
                            <h3 style={{ textDecoration: "underline" }}>RECOMENDACIONES:</h3>
                            <ul>
                                <p style={{ whiteSpace: 'pre-line' }}>{EvaluacionR}</p>
                            </ul>
                        </div>
                        <br></br>
                        <br></br>
                        <br></br>
                        {/*  <!-- Footer -->*/}
                        <div class="footer">
                            <p style={{ textDecoration: "underline" }}>{Empresa.descripcion}</p>
                            <p>{Empresa.tokenWhatsapp}</p>{/*<p>GASTROENTERÓLOGO</p>*/}
                            <p>EXC {Empresa.plantillaWhatsapp }</p>{/*17421*/}
                        </div>

                    </div>
                    </div>
                    </div>



                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*RECETA}*/}

            <div>

                <div  id="reciboPago3" hidden className="mt-4 p-3" >
                    
                    <div class="rotar-90">

                    <div class="hoja-timbrada">
                            <div class="MediapaginaHorizontal">
                        <div class="headerR" style={{background:"none"} }>
                            <img src="http://pichardo.systemapatech.com/imagen/mallaizquierda.webp" alt="Logo Izquierdo" class="logo-left"/>
                            <img src="http://pichardo.systemapatech.com/imagen/malladerecha.webp" alt="Logo Derecho" class="logo-right"/>
                            {/*<img src="http://pichardo.systemapatech.com/imagen/logogastro.webp" alt="Logo Central" class="logo-center" style={{ width: "200px" }} />*/}
                                    <img src={imageSrc} alt="Logo Central" class="logo-center" style={{ width: "150px" }} />
                                <h1 style={{ marginTop: "-10px" }} >{Empresa.descripcion}</h1>
                                              
                                <p class="subtitle">{Empresa.tokenWhatsapp}</p>
                                                {/*<p class="subtitle">Medicina Interna | Gastroenterología | Endoscopia Digestiva | Balón Gástrico</p>*/}
                        
                                <p class="subtitle">Exequátur No.{Empresa.plantillaWhatsapp } </p>{/*71204*/}
                                    <img src="http://pichardo.systemapatech.com/imagen/rxreceta.webp" alt="RX Logo" class="rx-logo" />
                                                </div>

                                                <div>
                            <table class="table" id="facturas-table" style={{ marginTop: "80px", fontSize: "20px", textTransform: "uppercase"} }>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                {ListadoReceta.map(x => (
                                    <tr>
                                        <td style={{ padding: "25px" } }>{x.nombreMedicamento}</td>
                                        <td style={{ padding: "25px" }}>{x.dosificacion}</td>
                                        <td style={{ padding: "25px" }}>{x.comentario}</td>
                                       
                                    </tr>
                                ))}
                                                    </table>

                                                </div>

                        <img src="http://pichardo.systemapatech.com/imagen/fondogastro.webp" alt="Background Image" class="background-image"/>

                                                    <div class="patient-info">
                                                        <div class="info-line">
                                <span>Nombre del Paciente:</span>
                                <b style={{ position: "absolute", marginLeft: "22%" }} >{(pacientenombres === "") ? pacientenombres : paciente.nombres + " " + paciente.apellidos}</b>
                                                        </div>
                                                        <div class="info-line">
                                                            <span>Firma:</span>
                                                        </div>
                                                        <div class="info-line">
                                                            <span>Fecha:</span>
                                                        </div>
                                                    </div>

                                                    <div class="footer">
                                                        <div class="footer-contact">
                                                            <div>
                                                                <img src="/imagen/ubicacion.png" alt="Ubicación" class="footer-icons"/>
                                        {Empresa.direccion}    {/*Clínica Dr. Rodríguez Santos: Calle Bartolomé Colón, No. 20, Villa Consuelo, D.N.*/}
                                                            </div>
                                                            <div>
                                                                <img src="/imagen/telefono.png" alt="Teléfono" class="footer-icons"/>
                                        {Empresa.telefono}
                                    <img src="/imagen/whatsapp.png" alt="Móvil" class="footer-icons" style={{ marginLeft: "1rem" }} />
                                        {Empresa.noWhatsapp}    {/*829-343-6584*/}
                                                                    </div>
                                                                    <div>
                                                                        <img src="/imagen/arroba.png" alt="Email" class="footer-icons"/>
                                            {Empresa.email}   {/*daly008@hotmail.com  @draydalinapichardo*/ }
                                                                    </div>
                                                            </div>
                                                            <div class="social-media">
                                                                <p>Síguenos:</p>
                                                                <img src="/imagen/Facebooklogo.svg" alt="Facebook" class="footer-icons"/>
                                                                    <img src="/imagen/Instagramlogo.png" alt="Instagram" class="footer-icons"/>
                                        <span>{Empresa.facebook }</span>
                                                                    </div>
                                                            </div>
                                                        </div>

                    </div>
                    </div>
                                                 </div>
            </div>


            {/**/}
            <Modal isOpen={VerSolicitud} className="modal-preguntas">
                <ModalHeader className="modal-header1" toggert={cerrarModalR} >


                    <div class="box">
                        <div>           seleccion: {tablaHistoria.nombrePaciente}</div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => cerrarModalR()}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div style={{ padding: "1rem", backgroundColor: "#f9f9f9" ,borderLeft: "5px solid #bb005e", borderRadius: "4px" }} >
                        <h3 style={{ color: "#bb005e", marginTop: "0" }}>¿Cómo seleccionar un estudio?</h3>
                        <p>
                            Para solicitar uno o más estudios clínicos para el paciente, simplemente <strong>marca las casillas</strong> que corresponden a los análisis requeridos.
                        </p>
                        <ul>
                            <li><strong>Hematología:</strong> Incluye estudios relacionados con las células sanguíneas.</li>
                            <li><strong>Química Sanguínea:</strong> Permite analizar glucosa, lípidos, proteínas, y otras sustancias en la sangre.</li>
                            <li>Al marcar una opción, esta será tomada en cuenta al momento de <strong>generar el formulario de impresión</strong> o al guardar la solicitud.</li>
                        </ul>
                        <p>
                            Asegúrate de revisar bien cada categoría y seleccionar solo los estudios necesarios. Si tienes dudas sobre un análisis, consulta con el médico encargado.
                        </p> <p>
Al final de la pagina imprimir.
                        </p>
                    </div>

                <div hidden>    <CSolicitudPruebasClinicas data={Empresa} p={pacientenombres} i={i} /></div>


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => cerrarModalR()}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/* Botón para abrir el modal */}
          

            {/* Modal */}
            <Modal isOpen={vermodal}  centered>
                <ModalHeader  className="bg-primary text-white">
                    Opciones de Impresión para {Impre.nombres + " " + Impre.apellidos}
                </ModalHeader>

                <ModalBody className="d-grid gap-3">
                    <Button color="warning" className="fw-bold text-dark shadow-sm" onClick={() => HistoriaClinica1(Impre)}>
                        CERTIFICADO
                    </Button>
                    <Button color="warning" className="fw-bold text-dark shadow-sm" onClick={() => HistoriaClinica(Impre)}>
                        HISTORIA CLÍNICA
                    </Button>
                    <Button color="warning" className="fw-bold text-dark shadow-sm" onClick={() => HistoriaClinica2(Impre)}>
                        EVALUACIÓN PRE-QUIRÚRGICA
                    </Button>
                    <Button color="warning" className="fw-bold text-dark shadow-sm" onClick={() => RecetaEnBlanco(Impre)}>
                        RECETA BLANCA
                    </Button>
                    <Button color="warning" className="fw-bold text-dark shadow-sm" onClick={() => (  SetVerSolicitud(true), Setpacientenombres(Impre.nombres + " " + Impre.apellidos), Seti(1) )}>
                        ESTUDIOS
                    </Button>

               



                </ModalBody>

                <ModalFooter>
                    <Button color="secondary" onClick={()=>setvermodal(false)}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
          
        </>
    )

}
export default Gastro;